import { AppConfig } from "../config/app-config";

export {
  deleteFileFromBlobStorage,
  uploadFileToBlobStorage,
} from "./object-storage/s3-utils";

/**
 * Creates a formatted page title with an optional application name suffix
 *
 * @param {string} title - The main title text
 * @param {boolean} addSuffix - Whether to append the application name as a suffix (defaults to true)
 * @returns {string} The formatted title string
 */
export function createTitle(title: string, addSuffix: boolean = true): string {
  if (!addSuffix) {
    return title;
  }
  if (!title) {
    return AppConfig.APP_NAME;
  }

  return `${title} | ${AppConfig.APP_NAME}`;
}

/**
 * Generates a cryptographically secure UUID (Universally Unique Identifier)
 *
 * @returns {string} A randomly generated UUID string
 */
export function generateUUID(): string {
  return crypto.randomUUID();
}

/**
 * Converts a string to sentence case
 *
 * @param str The string to convert
 * @returns The converted string
 */
export function toSentenceCase(str: string) {
  return str
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase())
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Checks if the query parameters match the path template
 *
 * @param queryParams The query parameters to check
 * @param pathTemplate The path template to match against
 * @returns True if the query parameters match the path template, false otherwise
 */
export function isQueryParamsValid(
  queryParams: string[],
  pathTemplate: string,
) {
  const pathParams = pathTemplate.match(/:(\{[a-zA-Z0-9]+\})/g);

  if (queryParams && pathParams && pathParams?.length !== queryParams.length) {
    return false;
  }
  return true;
}
